import { createStore } from 'vuex'
import menu from "./module/menu"

export default createStore({
    state: {
        isPhone: false
    },
    mutations: {
        setIsPhone: (state, val) => {
            state.isPhone = val;
        }
    },
    actions: {
    },
    modules: {
        menu
    }
})
